import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response, ResponseContentType } from '@angular/http';
import { HttpClientModule, HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';

//import { Observable } from 'rxjs/Observable';
import { Observable } from 'rxjs/Rx'
import { Subject } from 'rxjs/Subject';

import { Advisor } from '../models/advisor';
import { Client } from '../models/client';
import { Organization } from '../models/organization';

import { saveAs } from 'file-saver';

import { Router } from '@angular/router';

import Utils from '../shared/utility';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

//const env = 'https://apidev.hvsfinancial.com/api/';
//const env = 'http://api.hvsfinancial.com.loc/api/';
//const env = 'https://hvsportalpentestsvc.hvsfinancial.com/api/'; //zss PENTEST SERVICE
//const env = 'https://apiuat2.hvsfinancial.com/api/'; //Nationwide/redesign uat build
//const env = 'https://apidev2.hvsfinancial.com/api/'; //HVS uat build

 
//PROD
// const env = 'https://apidev3.hvsfinancial.com/api/'; //zss prod build
const env = 'https://portal-api.hvsfinancial.com/api/' // Prod2 - redesign

@Injectable()
export class GlobalService {
  env = env;
  //Global Asset URL
  assetURL = 'https://web234.hvsfinancial.com/portal-shared/'; // Prod
  //assetURL = 'https://hvswebuat1.hvsfinancial.com/portal/shared/';
  
  botURL = 'https://portal.hvsfinancial.com';
  //botURL = 'https://hvswebuat1.hvsfinancial.com';
  //botURL = 'https://hvswebuat1.hvsfinancial.com/vista/vista2.html';

  // isPre65Coverage: boolean;
  constructor(private _http: HttpClient,private http: Http, private router: Router) { }
  breadcrumbList: Array<any> = [];
  // 1 = SUPER ADMIN
  // 2 = ORGANIZATION ADMIN
  // 3 = ADVISOR
  // 4 = CLIENT

  hasSetFeatures = false;
  orgAccess;
  features;
  featHealthCare: boolean = false;//true;
  featMeansTesting: boolean = false;//true;
  featSocialSecurity: boolean = false;//true;
  featLongTermCare: boolean = false;//true;
  featTitan: boolean;
  featRiskTolerance: boolean;
  featHomeOffice: boolean;
  featCombinedHealthcareLTC: boolean = false;
  featFunding: boolean = false;
  featApplications: boolean = false;
  featExpressHealthcare: boolean = false;
  featQuickReports: boolean = false;  
  featAdditionalQuestions: boolean = false;
  featAbilityToDelete: boolean = false;
  featLTCMapReporting: boolean = false;
  featRetirementSuite: boolean = false;
  retirementSuiteUnlocked: boolean = false;
  allowedMicrotransactions: boolean = false;
  featChatBot: boolean = false;

  //displayChatBot: boolean = true;

  isSSOUser: boolean = false;

  isHVAM: boolean;

  isAltComplete: boolean;
  

  getAdvisorsData(UserType = 2): Observable<any[]> {
    let body = { UserType };
    // console.log(UserType);
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetUsers', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  getSupportTickets(): any[] {
    let ticketsStr = localStorage.getItem('hvs_support_tickets');
    if (!ticketsStr) {
      let mockTickets = [
        {
          id: 'ticket_1',
          userId: '101',
          userName: 'John Doe',
          subject: 'Issue with Social Security illustration',
          message: 'Hello, I am trying to run a Social Security illustration for my client, but the calculation seems to show 0 benefits. Could you please check?',
          status: 'Open',
          createdDate: '2026-07-15T10:00:00.000Z',
          comments: [
            {
              id: 'comment_1_1',
              userId: '1',
              userName: 'Super Admin',
              roleId: 1,
              message: 'Hi John, let me take a look at your client profile. Make sure the Date of Birth and Desired Claiming Age are correct.',
              createdDate: '2026-07-15T10:15:00.000Z'
            }
          ]
        },
        {
          id: 'ticket_2',
          userId: '102',
          userName: 'Alice Smith',
          subject: 'Cannot export Healthcare PDF report',
          message: 'Whenever I click the Download PDF button on the Healthcare express page, it shows an error saying "Cannot generate report". Please help!',
          status: 'Closed',
          createdDate: '2026-07-14T14:30:00.000Z',
          comments: [
            {
              id: 'comment_2_1',
              userId: '1',
              userName: 'Super Admin',
              roleId: 1,
              message: 'This issue should now be resolved. Please try again.',
              createdDate: '2026-07-14T15:00:00.000Z'
            },
            {
              id: 'comment_2_2',
              userId: '102',
              userName: 'Alice Smith',
              roleId: 3,
              message: 'Thank you! It works perfectly now.',
              createdDate: '2026-07-14T15:10:00.000Z'
            }
          ]
        }
      ];
      localStorage.setItem('hvs_support_tickets', JSON.stringify(mockTickets));
      return mockTickets;
    }
    return JSON.parse(ticketsStr);
  }

  saveSupportTickets(tickets: any[]): void {
    localStorage.setItem('hvs_support_tickets', JSON.stringify(tickets));
  }

  addSupportTicketLocal(subject: string, message: string): any {
    let tickets = this.getSupportTickets();
    let currentUserId = localStorage.getItem('userId') || '0';
    let currentUserName = (localStorage.getItem('firstName') || '') + ' ' + (localStorage.getItem('lastName') || '');
    if (currentUserName.trim() === '') {
      currentUserName = 'User #' + currentUserId;
    }
    let newTicket = {
      id: 'ticket_' + Date.now(),
      userId: currentUserId,
      userName: currentUserName,
      subject: subject,
      message: message,
      status: 'Open',
      createdDate: new Date().toISOString(),
      comments: []
    };
    tickets.unshift(newTicket);
    this.saveSupportTickets(tickets);
    return newTicket;
  }

  addCommentLocal(ticketId: string, message: string): void {
    let tickets = this.getSupportTickets();
    let ticket = tickets.find(t => t.id === ticketId);
    if (ticket) {
      let currentUserId = localStorage.getItem('userId') || '0';
      let currentUserName = (localStorage.getItem('firstName') || '') + ' ' + (localStorage.getItem('lastName') || '');
      if (currentUserName.trim() === '') {
        currentUserName = 'User #' + currentUserId;
      }
      let currentRoleId = Number(localStorage.getItem('roleId')) || 3;
      let newComment = {
        id: 'comment_' + Date.now(),
        userId: currentUserId,
        userName: currentUserName,
        roleId: currentRoleId,
        message: message,
        createdDate: new Date().toISOString()
      };
      ticket.comments.push(newComment);
      this.saveSupportTickets(tickets);
    }
  }

  updateTicketStatusLocal(ticketId: string, status: string): void {
    let tickets = this.getSupportTickets();
    let ticket = tickets.find(t => t.id === ticketId);
    if (ticket) {
      ticket.status = status;
      this.saveSupportTickets(tickets);
    }
  }

  hasCreatedSupportTickets(): boolean {
    let currentUserId = localStorage.getItem('userId') || '0';
    let tickets = this.getSupportTickets();
    return tickets.some(t => t.userId === currentUserId);
  }

  getReportsData(): Observable<any> {
    let body = { UserID: 2 };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetReports', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  getLegacyReportsData(): Observable<any> {
    let body = { };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetUserLegacyReports', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  getReportData(): Observable<any> {
    let body = { UserID: 2, ReportID: 1, ReportTypeID: 2 };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetReport', body, options)
      .map((res: Response) => {

        return res.json();
      })
      .catch(this.handleError);
  }

  getClientReportsData(UserID: number): Observable<any> {
    let body = { UserID };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetClientReports', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  getClientReportsDataSSO(clientID: any): Observable<any> {
    let body = { ClientID: clientID };
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'SSO/GetClientReports', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  getUserValidatedForClientReports(clientID: any): Observable<any> {
    let body = { ClientID: clientID };
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'SSO/NWInternal', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  getUser(UserID: number): Observable<any> {
    let body = { UserID: UserID };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetUserSSO', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  getAdvisorData(UserID: number): Observable<Advisor> {
    let body = { UserID: UserID };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetUser', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  getClientsData(): Observable<any[]> {
    let body = { UserType: 3 };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetUsers', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  getClientData(UserID: number, UserType: number): Observable<any> {
    let body = { UserID: UserID, UserType: UserType };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetUser', body, options)
      .map((res: Response) => {
        // console.log(res.json());
        return res.json();
      })
      .catch(this.handleError);
  }

  getOrganizationsData(): Observable<Organization[]> {
    let body = {};
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    console.log('getOrganizationsData');
    return this.http.post(env + 'CoreOrganization/GetOrganizations', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  getOrganizationData(OrgID: number): Observable<any> {
    let body = { ID: OrgID  };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetOrganization', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  GetRetirementSuite(OrgID: number): Observable<any> {
    let body = { ID: OrgID  };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetRetirementSuite', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }


  getMMTGraphData(client: any, mmtInputs: any, user): Observable<any> {
    // console.log('yoo', client, mmtInputs);
    let People = [{
      Gender: client.client.GenderID,
      CurrentIncome: client.clientProfile.CurrentIncome,
      DateOfBirth: client.client.DOB,
      conditions: client.clientProfile.HealthConditions || [], // Fix this
      RetirementAge: client.clientProfile.RetirementAge,
      RetirementState: client.clientProfile.RetirementState,
      PensionAmount: client.clientProfile.Pension,
      SocialSecurityPia: mmtInputs.SSMonthlyBenefit,
      SocialSecurityRetirementAge: mmtInputs.SocialSecurityRetirementAge,
      LifeExpectancy: client.clientProfile.LifeExpectancy || 0,
    }];

    if (mmtInputs.IncludePartner) {
      let partnerPensionAmout = Number(client.clientProfile.Spouses[0].pension);
      People.push({
        Gender: client.clientProfile.Spouses[0].gender,
        CurrentIncome: client.clientProfile.Spouses[0].currentIncome,
        DateOfBirth: client.clientProfile.Spouses[0].dob,
        conditions: client.clientProfile.Spouses[0].healthConditions || [], // Fix this
        RetirementAge: client.clientProfile.Spouses[0].retirementAge,
        PensionAmount: partnerPensionAmout,
        SocialSecurityPia: mmtInputs.PartnerSSMonthlyBenefit,
        SocialSecurityRetirementAge: mmtInputs.PartnerSocialSecurityAge,
        RetirementState: client.clientProfile.Spouses[0].state,
        LifeExpectancy: client.clientProfile.Spouses[0].LifeExpectancy || 0,
      });

      // client.clientProfile.Spouses = JSON.parse(client.clientProfile.Spouses);
    }
    // console.log(People);

    let body = { People, IRR: client.clientProfile.IRR , HCModelVersion: 6, SalaryIncrease: mmtInputs.InflationRate, retirementState: client.clientProfile.RetirementState, PercentIncomeMAGI: mmtInputs.MagiIncomePercent, clientProfile: JSON.stringify(client.clientProfile), CompanyCode: user.CompanyCode, UserID: user.UserID, ClientID: user.ClientID }; // TODO: Grab organization HCModelVersion
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreReports/MedicareMeansTestingGraph', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  // TODO: Update to use proper models instead of `any`
  getMMTData(client: any, mmtInputs: any, user, isMMTIllustrationPage: boolean = false): Observable<any> {

    // Some forms only ask for household income, in married scenarios, 50% of income should be applied to client and 50% to spouse
    const isHouseholdIncome = client.clientProfile.CurrentIncome >= 0 && client.clientProfile.Spouses.length > 0 && client.clientProfile.Spouses[0].maritalStatus == 'Married' && !client.clientProfile.Spouses[0].currentIncome;

    let People = [{
      Gender: client.client.GenderID,
      CurrentIncome: isHouseholdIncome ? (Number(client.clientProfile.CurrentIncome) / 2) : mmtInputs.IncludePartner ? (Number(client.clientProfile.CurrentIncome) + Number(client.clientProfile.Spouses[0].currentIncome)) / 2 : Number(client.clientProfile.CurrentIncome),
      // DateOfBirth: client.client.DOB.split(' ')[0],
      DateOfBirth: new Date(client.client.DOB.split(' ')[0]).toLocaleDateString(),
      conditions: client.clientProfile.HealthConditions || [], // Fix this
      RetirementAge: client.clientProfile.RetirementAge,
      RetirementState: client.clientProfile.RetirementState,
      PensionAmount: client.clientProfile.Pension || 0,
      SocialSecurityPia: mmtInputs.SSMonthlyBenefit || 0,
      SocialSecurityRetirementAge: mmtInputs.SocialSecurityRetirementAge,
      LifeExpectancy: client.clientProfile.LifeExpectancy || 0,
      RetirementWages : client.clientProfile.InRetFirstYearIncome || 0,
      RetirementStopAge : client.clientProfile.InRetStopWorkAge || 0,
      YearOneRetIncome: client.clientProfile.HouseholdYearOneIncome || 0,
      PreRetInlfationRate: (client.clientProfile.InflationRate || 0)/100
    }];

    if (mmtInputs.IncludePartner) {
      let partnerPensionAmout = Number(client.clientProfile.Spouses[0].pension);
      People.push({
        Gender: client.clientProfile.Spouses[0].gender,
        CurrentIncome: isHouseholdIncome ? (Number(client.clientProfile.CurrentIncome) / 2) : (Number(client.clientProfile.Spouses[0].currentIncome) + Number(client.clientProfile.CurrentIncome)) / 2,
        // DateOfBirth:  client.clientProfile.Spouses[0].dob.split(' ')[0],
        DateOfBirth: new Date(client.clientProfile.Spouses[0].dob.split(' ')[0]).toLocaleDateString(),
        conditions: client.clientProfile.Spouses[0].healthConditions || [], // Fix this
        RetirementAge: client.clientProfile.Spouses[0].retirementAge,
        PensionAmount: partnerPensionAmout || 0,//client.clientProfile.Spouses[0].pension,
        SocialSecurityPia: mmtInputs.PartnerSSMonthlyBenefit || 0,
        SocialSecurityRetirementAge: mmtInputs.PartnerSocialSecurityAge,
        RetirementState: client.clientProfile.Spouses[0].state,
        LifeExpectancy: client.clientProfile.Spouses[0].LifeExpectancy || 0,
        RetirementWages : client.clientProfile.Spouses[0].inRetFirstYearIncome || 0,
        RetirementStopAge : client.clientProfile.Spouses[0].inRetStopWorkAge || 0,
        YearOneRetIncome: 0,
        PreRetInlfationRate: 0
      });

      // client.clientProfile.Spouses = JSON.parse(client.clientProfile.Spouses);
    }
    
    console.log('MMT people', People);

    const yearlyColas = JSON.parse(localStorage.getItem('yearlyValues')) || { BaseYear: 2024, Year1: 3.2, Year2: 2.2, Year3: 2.4, Year4: 2.4 };
    const colas = [
      { Year: yearlyColas.BaseYear, Cola : yearlyColas.Year1 },
      { Year: yearlyColas.BaseYear + 1, Cola : yearlyColas.Year2 },
      { Year: yearlyColas.BaseYear + 2, Cola : yearlyColas.Year3 },
      { Year: yearlyColas.BaseYear + 3, Cola : yearlyColas.Year4 }
    ]

    let body = { People, 
      IRR: client.clientProfile.IRR || 75, 
      HCModelVersion: 6, 
      SalaryIncrease: mmtInputs.InflationRate, 
      retirementState: client.clientProfile.RetirementState == 'NA'? '' : client.clientProfile.RetirementState, 
      PercentIncomeMAGI: mmtInputs.MagiIncomePercent, 
      clientProfile: JSON.stringify(client.clientProfile), 
      CompanyCode: user.CompanyCode, 
      UserID: user.UserID, 
      ClientID: user.ClientID,
      Colas: JSON.stringify(colas),
      MidRetAdjYear: client.midRetirementAdj ? client.midRetirementAdj.Year : 0,
      MidRetRedPer:  client.midRetirementAdj ? (client.midRetirementAdj.ReductionPerc == null) ? null : client.midRetirementAdj.ReductionPerc / 100 : 0,
      MidRetRedDollar:  client.midRetirementAdj ? (client.midRetirementAdj.ReductionDollar == null) ? null : client.midRetirementAdj.ReductionDollar : 0,
      MidRetIncomeInflationRate:  client.midRetirementAdj ? (client.midRetirementAdj.IncomeInflationRate) / 100 : 0,
      InRetInflationRate:  (client.clientProfile.InRetirementInflationRate || 0)/100,
      IsMMTIllustrationPage: isMMTIllustrationPage
    }; // TODO: Grab organization HCModelVersion
    
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    return this.http.post(env + 'CoreReports/MedicareMeansTestingReport', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  getMMTBracket(includePartner, bracketYear=0): Observable<any> {
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    let body = {IncludePartner: includePartner, BracketYear:bracketYear};
    console.log('body', body);
    return this.http.post(env + 'CoreOrganization/GetMMTBracket', body, options)
    .map((res: Response) => {
      return res.json();
    })
    .catch(this.handleError)

  }

  // TODO: Update to use proper models instead of `any`
  getSSData(ssInputs, user): Observable<any> {
    // let People = [{
    //   CurrentAge: mmtInputs.currentAge,
    //   Gender: client.client.GenderID,
    //   CurrentIncome: client.clientProfile.CurrentIncome,
    //   DateOfBirth: client.client.DOB,
    //   conditions: client.clientProfile.HealthConditions || [],
    //   SSMonthlyBenefit: mmtInputs.ssMonthlyBenefit,
    //   RetirementAge: mmtInputs.ssStartAge,
    // }];

    // console.log(ssInputs);

    // console.log("Here's what gets sent to the server:", ssInputs);

    let body = { SSRequestObject: ssInputs, CompanyCode: user.CompanyCode, UserID: user.UserID, ClientID: user.ClientID  }; // TODO: Grab organization HCModelVersion
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    //console.log("SS Data: ", JSON.stringify(body));
    return this.http.post(env + 'CoreReports/SocialSecurityReport', body, options)
      .map((res: Response) => {
        // console.log("Here's the response from the server:", res.json());
        return res.json();
      })
      .catch(this.handleError);
  }

  getSSDataTBC(ssInputs, user): Observable<any> {
   
    let body = { SSRequestObject: ssInputs, CompanyCode: user.CompanyCode, UserID: user.UserID, ClientID: user.ClientID  }; // TODO: Grab organization HCModelVersion
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    //console.log("SS Data: ", JSON.stringify(body));
    return this.http.post(env + 'CoreReports/SocialSecurityTBCReport', body, options)
      .map((res: Response) => {
        // console.log("Here's the response from the server:", res.json());
        return res.json();
      })
      .catch(this.handleError);
  }

  getLTCData(ltcData: any, queryInfo: any): Observable<any> {
    let body = { ltcData, reportType: (queryInfo.reportType) ? queryInfo.reportType : 4, clientID: queryInfo.clientID, userID: queryInfo.userID, orgID: queryInfo.orgID, clientRetirementAge: queryInfo.clientRetirementAge, partnerRetirementAge: queryInfo.partnerRetirementAge };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    body.ltcData.ClientCareTypes = [...body.ltcData.ClientCareTypes].reverse();
    body.ltcData.SpouseCareTypes = [...body.ltcData.SpouseCareTypes].reverse();

    return this.http.post(env + 'CoreReports/LongTermCareReport', body, options)
      .map((res: Response) => {
        // console.log(res.json());
        return res.json();
      })
      .catch(this.handleError);
  }

  getLTCStateRegions(stateAbbr: any): Observable<any> {
    let body = { state: stateAbbr };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreReports/GetStateRegions', body, options)
      .map((res: Response) => {
        // console.log(res.json());
        return res.json();
      })
      .catch(this.handleError);
  }

  getLTCExpensesData(body: any): Observable<any> {
    //let body = { ltcData, clientID: queryInfo.clientID, userID: queryInfo.userID, orgID: queryInfo.orgID };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreReports/LongTermCareExpenses', body, options)
      .map((res: Response) => {
        // console.log(res.json());
        return res.json();
      })
      .catch(this.handleError);
  }

  getLTCDataVx(body: any): Observable<any> {
    //let body = { ltcData, clientID: queryInfo.clientID, userID: queryInfo.userID, orgID: queryInfo.orgID };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreReports/LongTermCareReportVx', body, options)
      .map((res: Response) => {
        // console.log(res.json());
        return res.json();
      })
      .catch(this.handleError);
  }

  resetPassword(body: any): Observable<any> {
    //let body = { ltcData, clientID: queryInfo.clientID, userID: queryInfo.userID, orgID: queryInfo.orgID };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/ResetPassword', body, options)
      .map((res: Response) => {
        // console.log(res.json());
        return res.json();
      })
      .catch(this.handleError);
  }

  // TODO: Update to use proper models instead of `any`
  getHCData(client: any, pExpenses: any, oopExpenses: any, spouse: any, includePartner: boolean): Observable<any> {
    let People = [{
      CurrentAge: client.clientProfile.CurrentAge,
      Gender: client.client.GenderID,
      CurrentIncome: client.clientProfile.CurrentIncome,
      RetirementAge: client.clientProfile.RetirementAge,
      RetirementState: client.clientProfile.RetirementState,
      DateOfBirth: client.client.DOB,
      conditions: JSON.stringify({
        HCHBP: client.clientProfile.HCHBP,
        HCHC: client.clientProfile.HCHC,
        HCT2D: client.clientProfile.HCT2D,
        HCCD: client.clientProfile.HCCD,
        HCC: client.clientProfile.HCC,
        HCT: client.clientProfile.HCT,
      })
    }];

    if (includePartner) {
      People.push({
        CurrentAge: 0,
        Gender: spouse.gender,
        CurrentIncome: spouse.currentIncome,
        RetirementAge: spouse.retirementAge,
        RetirementState: client.clientProfile.RetirementState,
        DateOfBirth: spouse.dob,
        conditions: JSON.stringify({
          HCHBP: client.clientProfile.Spouses[0].HCHBP,
          HCHC: client.clientProfile.Spouses[0].HCHC,
          HCT2D: client.clientProfile.Spouses[0].HCT2D,
          HCCD: client.clientProfile.Spouses[0].HCCD,
          HCC: client.clientProfile.Spouses[0].HCC,
          HCT: client.clientProfile.Spouses[0].HCT,
        })
        //spouse.healthConditions || [],
      });
    }

    // console.log("PEOPLE", People);
    let premiumExpenses = {
      partB: pExpenses.partB,
      partD: pExpenses.partD,
      medigap: pExpenses.medigap,
      dental: pExpenses.dental
    }

    let outOfPocketExpenses = {
      hospitalization: oopExpenses.hospitalization,
      docsTests: oopExpenses.docsTests,
      rx: oopExpenses.rx,
      dental: oopExpenses.dental,
      hearingServices: oopExpenses.hearingServices,
      vision: oopExpenses.vision,
      commercial: oopExpenses.commercial
    }

    let body = { People, HCModelVersion: 6, retirementState: client.clientProfile.RetirementState, premiumExpenses, outOfPocketExpenses, clientProfile: JSON.stringify(client.clientProfile) }; // TODO: Grab organization HCModelVersion
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });


    return this.http.post(env + 'CoreReports/HealthCareReport', body, options)
      .map((res: Response) => {
        // console.log(res.json());
        return res.json();
      })
      .catch(this.handleError);
  }


  getHCDataV2(ReportHC, user): Observable<any> {
    // let People = [{
    //   CurrentAge: client.clientProfile.CurrentAge,
    //   Gender: client.client.GenderID,
    //   CurrentIncome: client.clientProfile.CurrentIncome,
    //   RetirementAge: client.clientProfile.RetirementAge,
    //   RetirementState: client.clientProfile.RetirementState,
    //   DateOfBirth: client.client.DOB,
    //   conditions: JSON.stringify({
    //     HCHBP: client.clientProfile.HCHBP,
    //     HCHC: client.clientProfile.HCHC,
    //     HCT2D: client.clientProfile.HCT2D,
    //     HCCD: client.clientProfile.HCCD,
    //     HCC: client.clientProfile.HCC,
    //     HCT: client.clientProfile.HCT,
    //   })
    // }];

    // if (includePartner) {
    //   People.push({
    //     CurrentAge: 0,
    //     Gender: spouse.gender,
    //     CurrentIncome: spouse.currentIncome,
    //     RetirementAge: spouse.retirementAge,
    //     RetirementState: client.clientProfile.RetirementState,
    //     DateOfBirth: spouse.dob,
    //     conditions: JSON.stringify({
    //       HCHBP: client.clientProfile.Spouses[0].HCHBP,
    //       HCHC: client.clientProfile.Spouses[0].HCHC,
    //       HCT2D: client.clientProfile.Spouses[0].HCT2D,
    //       HCCD: client.clientProfile.Spouses[0].HCCD,
    //       HCC: client.clientProfile.Spouses[0].HCC,
    //       HCT: client.clientProfile.Spouses[0].HCT,
    //     })
    //     //spouse.healthConditions || [],
    //   });
    // }

    // console.log("PEOPLE", People);
    // let premiumExpenses = {
    //   partB: pExpenses.partB,
    //   partD: pExpenses.partD,
    //   medigap: pExpenses.medigap,
    //   dental: pExpenses.dental
    // }

    // let outOfPocketExpenses = {
    //   hospitalization: oopExpenses.hospitalization,
    //   docsTests: oopExpenses.docsTests,
    //   rx: oopExpenses.rx,
    //   dental: oopExpenses.dental,
    //   hearingServices: oopExpenses.hearingServices,
    //   vision: oopExpenses.vision,
    //   commercial: oopExpenses.commercial
    // }

    let body = { ReportHC, reportType: (user.reportType) ? user.reportType : 3, CompanyCode: user.CompanyCode, UserID: user.UserID, ClientID: user.ClientID   }; // TODO: Grab organization HCModelVersion
    //console.log("V2 Data: ", JSON.stringify(body));
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });


    return this.http.post(env + 'CoreReports/HealthCareReportV2', body, options)
      .map((res: Response) => {
        // console.log(res.json());
        return res.json();
      })
      .catch(this.handleError);
  }

  getCombinedData(ReportHC, ltcData, user): Observable<any> {
    let body = { ReportHC, ltcData: ltcData, CompanyCode: user.CompanyCode, UserID: user.UserID, ClientID: user.ClientID, orgID: user.orgID, clientRetirementAge: user.clientRetirementAge, partnerRetirementAge: user.partnerRetirementAge }; // TODO: Grab organization HCModelVersion
    //console.log("V2 Data: ", JSON.stringify(body));
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    body.ltcData.ClientCareTypes = [...body.ltcData.ClientCareTypes].reverse();
    body.ltcData.SpouseCareTypes = [...body.ltcData.SpouseCareTypes].reverse();

    return this.http.post(env + 'CoreReports/CombinedReport', body, options)
      .map((res: Response) => {
        // console.log(res.json());
        return res.json();
      })
      .catch(this.handleError);
  }

  createOrganization(OrganizationModel: any) {
    let body = OrganizationModel;
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/UpdateOrganization', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  generateLegacyReport(report) {
    let body = { report };
    let headers = new Headers({ 
      'Authorization': `bearer ${localStorage.getItem('bearer')}`,
      'Accept': 'application/pdf',
    });

    // console.log(report);

    return this.http.post(env + 'CoreOrganization/DownloadableLegacyReport', body, { responseType: ResponseContentType.Blob, headers  })
      .map((res: Response) => {
        var blob = new Blob([res.blob()], { type: 'application/pdf' });
        var reportName = report.title;

        if (report.reportTypeID) {
          reportName += report.reportTypeID == 1 ? "Social_Security_Report" : report.reportTypeID == 2 ? "Means_Testing_Report" : "Health_Care_Report";
        } else {
          reportName += report.ReportTypeID == 1 ? "Social_Security_Report" : report.ReportTypeID == 2 ? "Means_Testing_Report" : "Health_Care_Report";
        }
        
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, reportName + '.pdf');
        }
        else {
          var url = window.URL.createObjectURL(blob);
          window.open(url);
          saveAs(blob, reportName + ".pdf");
        }

        return res.json();
      })
      .catch(this.handleError);
  }

  generateReport(ReportFields, client, report, hasAlternate = false, isHealthcareExpress = false) {
    // console.log(ReportFields);
    let body = { ReportFields, hasAlternate: hasAlternate, isHealthcareExpress: isHealthcareExpress };
    //console.log("PDF Obj: ",JSON.stringify(body));
    let headers = new Headers({ 
      'Authorization': `bearer ${localStorage.getItem('bearer')}`,
      'Accept': 'application/pdf',
    });

    let reportUrl =  'GetDownloadableReport';

    if (Number(report.ReportTypeID || report.reportTypeID) == 5) {
      reportUrl = 'GetRiskToleranceHealthcareReport';
    } else if (Number(report.ReportTypeID || report.reportTypeID) == 7) {
      reportUrl = 'GetRiskToleranceLongtermCareReport'
    }

    return this.http.post(env + `GenReport/${reportUrl}`, body, { responseType: ResponseContentType.Blob, headers  })
      .map((res: Response) => {        
        var blob = new Blob([res.blob()], { type: 'application/pdf' });

        if (client.FirstName) {
          var reportName = client.FirstName + "_" + client.LastName + "_";
        } else {
          var reportName = client.firstName + "_" + client.lastName + "_";
        }
        
        let type = "";
        console.log('res');
        console.log(res);
      
        switch(Number(report.ReportTypeID || report.reportTypeID)) {
          case 1:
              type = 'Social_Security_Report'
            break;
          case 2:
              type = 'Medicare_Means_Testing_Report'
            break;
          case 3:
              type = 'Healthcare_Report'
            break;
          case 4:
              type = 'Longterm_Care_Report'
            break;
            case 5:
            type = 'Risk_Tolerance_Healthcare_Report'
            break;
          /* case 6:
            type = 'Risk_Tolerance_Social_Security_Report'
            break; */
          case 7:
            type = 'Risk_Tolerance_Longterm_Care_Report'
            break;
            case 8:
              type = 'Combined_HC_LTC_Report'
            break;
            case 9:
              type = 'Healthcare_Report'
            break;
            case 10:
              type = 'Longterm_Care_Report'
            break;
            case 11:
              type = 'Social_Security_Report'
            break;
            case 12:
              type = 'Medicare_Means_Testing_Report'
            break;
            case 13:
              type = 'Combined_HC_LTC_Report'
            break;
          default:
            break;
        }

        reportName += type;

        // console.log('inside', report, client);
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, reportName + '.pdf');
        }
        else {
          var url = window.URL.createObjectURL(blob);
          window.open(url);
          saveAs(blob, reportName + ".pdf");
        }

        return res.json();
      })
      .catch(this.handleError);
  }
  
  createReport(Report: any, ReportMMT: any) {
    let body = { Report, ReportMMT };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    // console.log(Report, ReportMMT);
    return this.http.post(env + 'CoreOrganization/CreateMMTReport', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  createReportCombined(Report: any, ReportCombined: any) {
    let body = { Report, ReportCombined };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    // console.log("create HC: ", JSON.stringify(body));
    return this.http.post(env + 'CoreOrganization/CreateCombinedReport', body, options)
      .map((res: Response) => {
        var result = res.json();
        return res.json();
      })
      .catch(this.handleError);
  }

  createReportHC(Report: any, ReportHC: any) {
    let body = { Report, ReportHC };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    // console.log("create HC: ", JSON.stringify(body));
    return this.http.post(env + 'CoreOrganization/CreateHCReport', body, options)
      .map((res: Response) => {
        var result = res.json();
        return res.json();
      })
      .catch(this.handleError);
  }

  createReportLTC(Report: any, ReportLTC: any) {
    let body = { Report, ReportLTC };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/CreateLTCReport', body, options)
      .map((res: Response) => {
        var result = res.json();
        return res.json();
      })
      .catch(this.handleError);
  }

  createReportSS(Report: any, ReportSS: any) {
    let body = { Report, ReportSS };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    // console.log(Report, ReportSS);
    return this.http.post(env + 'CoreOrganization/CreateSSReport', body, options)
      .map((res: Response) => {
        var result = res.json();
        return res.json();
      })
      .catch(this.handleError);
  }

  deleteReport(Report: any){
    let body = { Report };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    // console.log(Report, ReportSS);
    return this.http.post(env + 'CoreOrganization/DeleteReport', body, options)
      .map((res: Response) => {
        var result = res.json();
        return res.json();
      })
      .catch(this.handleError);
  }

  createClient(UserModel: any, ClientProfile: any, RiskTolerance: any, AdditionalQuestion?: any, MidRetirementAdj?: any, LstMAGIProj?: any[] ): Observable<any> {
    let body;


    if (typeof AdditionalQuestion !== 'undefined' && typeof MidRetirementAdj !== 'undefined' && typeof LstMAGIProj !== 'undefined') {
      body = { UserModel, ClientProfile, RiskTolerance, AdditionalQuestion, MidRetirementAdj, LstMAGIProj };
    } else if (typeof AdditionalQuestion !== 'undefined') {
      body = { UserModel, ClientProfile, RiskTolerance, AdditionalQuestion };
    } else {
      body = { UserModel, ClientProfile, RiskTolerance};
    }

    if (ClientProfile.InRetStopWorkAge && ClientProfile.LifeExpectancy < ClientProfile.InRetStopWorkAge) {
      ClientProfile.InRetStopWorkAge = ClientProfile.LifeExpectancy;
    }

    if (ClientProfile.Spouses && JSON.parse(ClientProfile.Spouses)[0] && JSON.parse(ClientProfile.Spouses)[0].inRetStopWork && JSON.parse(ClientProfile.Spouses)[0].LifeExpectancy < JSON.parse(ClientProfile.Spouses)[0].inRetStopWork) {
      const spouses = JSON.parse(ClientProfile.Spouses);
      spouses[0].inRetStopWork = spouses[0].LifeExpectancy;
      ClientProfile.Spouses = JSON.stringify(spouses);
    }

    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/UpdateClient', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  createAdvisor(UserModel: any): Observable<any> {
    let body = { UserModel };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/UpdateAdvisor', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  updateAdvisor(UserModel: any): Observable<any> {
    let body = { UserModel };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/UpdateAdvisor', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  UploadOrgDoc(formData: any): Observable<any> {
    let headers = new Headers({ 'Authorization': `bearer ${localStorage.getItem('bearer')}` });

    let options = new RequestOptions({ headers: headers });

    return this.http.post(env + 'CoreOrganization/UploadOrgDoc', formData, options)
      .map((res: Response) => {
        return res;
      })
      .catch(this.handleError);
  }

  uploadOrgLogo(formData: any): Observable<any> {
    // let headers = new Headers();
    let headers = new Headers({ 'Authorization': `bearer ${localStorage.getItem('bearer')}` });

    let options = new RequestOptions({ headers: headers });
    // let apiUrl1 = "http://api.hvsfinancial.com.loc/api/CoreRegistration/UploadProfilePhoto";

    return this.http.post(env + 'CoreOrganization/UploadOrgLogo', formData, options)
      .map((res: Response) => {
        return res;
      })
      .catch(this.handleError);

      // .map(res => res.json())
      // .catch(error => Observable.throw(error))
      // .subscribe(
      // data => console.log(data + 'success'),
      // error => console.log(error)
      // )
  }

  saveProfileImage(formData: any): Observable<any> {
    // let headers = new Headers();
    let headers = new Headers({ 'Authorization': `bearer ${localStorage.getItem('bearer')}` });

    let options = new RequestOptions({ headers: headers });
    // let apiUrl1 = "http://api.hvsfinancial.com.loc/api/CoreRegistration/UploadProfilePhoto";

    return this.http.post(env + 'CoreOrganization/UploadProfilePhoto', formData, options)
      .map((res: Response) => {
        return res;
      })
      .catch(this.handleError);

      // .map(res => res.json())
      // .catch(error => Observable.throw(error))
      // .subscribe(
      // data => console.log(data + 'success'),
      // error => console.log(error)
      // )
  }

  getProfileImage(): Observable<any> {
    let headers = new Headers({ 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers: headers });

    return this.http.post(env + 'CoreOrganization/GetProfileImage', {}, options)
      .map((res: Response) => {
        // console.log(res);
        return res;
      })
      .catch(this.handleError);
  }

  createSupportTicket(SupportModel: any): Observable<any> {
    let body = { SupportModel };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/CreateSupportTicket', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  consumerTools(UserModel: any): Observable<any> {
    let body = { UserModel };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/ConsumerTools', body, options)
      .map((res: any) => {
        return res._body;
      })
      .catch(this.handleError);
  }

  getPIA(PIACalculator: any): Observable<any> {
    let body = { PIACalculator };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    // console.log(PIACalculator);
    return this.http.post(env + 'CoreReports/GetPIA', body, options)
      .map((res: any) => {
        // console.log(res);
        // return res._body;
        return res._body;
      })
      .catch(this.handleError);
  }

  getLE(LEObject: any): Observable<any> {
    let body = { LEObject };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post(env + 'CoreReports/GetLE', body, options)
      .map((res: any) => {
        return res._body;
      })
      .catch(this.handleError);
  }

  getMetrics(): Observable<any> {
    let body = {};
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post(env + 'CoreOrganization/GetMetrics', body, options)
      .map((res: any) => {
        // console.log(res.json());
        // return res._body;
        return res.json();
      })
      .catch(this.handleError);
  }

  getUnassignedLeads(): Observable<any> {
    let body = {};
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post(env + 'CoreOrganization/GetUnassignedLeads', body, options)
      .map((res: any) => {
        // console.log(res.json());
        return res.json();
      })
      .catch(this.handleError);
  }

  getUserLeads(): Observable<any> {
    let body = {};
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post(env + 'CoreOrganization/GetUserLeads', body, options)
      .map((res: any) => {
        // console.log(res.json());
        return res.json();
      })
      .catch(this.handleError);
  }

  getLeadInfo(leadRelationshipId): Observable<any> {
    let body = { LeadRelationshipId : leadRelationshipId };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post(env + 'CoreOrganization/GetLeadInfo', body, options)
      .map((res: any) => {
        // console.log(res.json());
        return res.json();
      })
      .catch(this.handleError);
  }

  assignLead(leadRelationshipId, advisorId): Observable<any> {
    let body = { LeadRelationshipId : leadRelationshipId, AdvisorID: advisorId  };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post(env + 'CoreOrganization/ReassignLead', body, options)
      .map((res: any) => {
        // console.log(res.json());
        return res.json();
      })
      .catch(this.handleError);
  }

  archiveLead(leadRelationshipId): Observable<any> {
    let body = { LeadRelationshipId : leadRelationshipId };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post(env + 'CoreOrganization/ArchiveLead', body, options)
      .map((res: any) => {
        // console.log(res.json());
        return res.json();
      })
      .catch(this.handleError);
  }

  updateOrgInfo(org): Observable<any> {
    let body = { Organization : org };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post(env + 'CoreOrganization/UpdateOrgInfo', body, options)
      .map((res: any) => {
        // console.log(res.json());
        //return res.json();
      })
      .catch(this.handleError);
  }

  UploadDocumentItem(doc): Observable<any> {
    let body = { Document : doc };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post(env + 'CoreOrganization/UploadDocumentItem', body, options)
      .map((res: any) => {
        // console.log(res);
        // console.log(res.json());
        return res; //.json();
      })
      .catch(this.handleError);
  }

  GetMarketingMaterial(): Observable<any> {
    let body = { };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post(env + 'CoreOrganization/GetMarketingMaterial', body, options)
      .map((res: any) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  ReplaceInfoCenter(infoCenter): Observable<any> {
    let body = { infoCenter: JSON.stringify(infoCenter) };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post(env + 'CoreOrganization/ReplaceInfoCenter', body, options)
      .map((res: any) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  ReplaceMarketingMaterial(marketingMaterial): Observable<any> {
    let body = { marketingMaterial: JSON.stringify(marketingMaterial) };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    // console.log('update', marketingMaterial)
    
    return this.http.post(env + 'CoreOrganization/ReplaceMarketingMaterial', body, options)
      .map((res: any) => {
        // console.log(res)
        return res.json();
      })
      .catch(this.handleError);
  }

  GetPaymentToken(): Observable<any> {
    let body = { };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post(env + 'CoreOrganization/GetPaymentToken', body, options)
      .map((res: any) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  CompletePayment(obj): Observable<any> {
    // console.log(arguments);
    let body = { obj };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post(env + 'CoreRegistration/CompletePayment', body, options)
      .map((res: any) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  ValidateUsernameEmail(username, email): Observable<any> {
    let body = { username, email };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreRegistration/ValidateUsernameEmail', body, options)
      .map((res: any) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  GetPricing(obj): Observable<any> {
    // console.log(arguments);
    let body = obj;
    let headers = new Headers({ 'Content-Type': 'application/json','Accept': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post(env + 'CoreRegistration/GetPricing', body, options)
      .map((res: any) => {
        // console.log(res);
        return res.json();
      })
      .catch(this.handleError);
  }

  GetOrganizationInfo(obj): Observable<any> {
    // console.log(arguments);
    let body = obj;
    let headers = new Headers({ 'Content-Type': 'application/json','Accept': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post(env + 'CoreRegistration/GetOrganizationInfo', body, options)
      .map((res: any) => {
        // console.log(res);
        return res.json();
      })
      .catch(this.handleError);
  }

  GetInfoCenter(): Observable<any> {
    let body = { };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post(env + 'CoreOrganization/GetInfoCenter', body, options)
      .map((res: any) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  SignOut(){
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/UpdateUser', {}, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  // getMetricDataLegacy(metricObject): Observable<any> {
  //   let body = metricObject;
  //   let headers = new Headers({ 
  //     'Authorization': `bearer ${localStorage.getItem('bearer')}`,
  //     'Accept': 'application/vnd.ms-excel',
  //   });
  //   let options = new RequestOptions({ headers });

  //   // return this.http.post(env + 'CoreOrganization/GetOrganizationMetrics', body, { responseType: ResponseContentType.Blob, headers  })
  //   return this.http.post(env + 'CoreOrganization/GetOrganizationMetricsLegacy', body, options)
  //     .map((res: Response) => {        
        
  //       return res.json();
  //     })
  //     .catch(this.handleError);
  // }

  getMetricDataLegacy(metricObject): Observable<any> {
    let body = metricObject;
    let headers = new Headers({ 
      'Authorization': `bearer ${localStorage.getItem('bearer')}`,
      'Accept': 'application/vnd.ms-excel',
    });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetOrganizationMetricsLegacy', body, { responseType: ResponseContentType.Blob, headers  })
      .map((res: Response) => {        
        var blob = new Blob([res.blob()], { type: 'application/vnd.ms-excel' });

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, 'metric-data.xlsx');
        }
        else {
          var url = window.URL.createObjectURL(blob);
          window.open(url);
          saveAs(blob, 'metric-data.xlsx');
        }
      })
      .catch(this.handleError);
  }

  getMetricData(metricObject): Observable<any> {
    let body = metricObject;
    let headers = new Headers({ 
      'Authorization': `bearer ${localStorage.getItem('bearer')}`,
      'Accept': 'application/vnd.ms-excel',
    });
    let options = new RequestOptions({ headers });

    // return this.http.post(env + 'CoreOrganization/GetOrganizationMetrics', body, { responseType: ResponseContentType.Blob, headers  })
    return this.http.post(env + 'CoreOrganization/GetOrganizationMetrics', body, options)
      .map((res: Response) => {        
        
        return res.json();
      })
      .catch(this.handleError);
  }

  getMetricDownloadableReport(metricObject): Observable<any> {
    let body = metricObject;
    let headers = new Headers({ 
      'Authorization': `bearer ${localStorage.getItem('bearer')}`,
      'Accept': 'application/vnd.ms-excel',
    });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetMetricDownloadableReport', body, { responseType: ResponseContentType.Blob, headers  })
      .map((res: Response) => {        
        var blob = new Blob([res.blob()], { type: 'application/vnd.ms-excel' });

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, 'metric-data.xlsx');
        }
        else {
          //var url = window.URL.createObjectURL(blob);
          //window.open(url);
          saveAs(blob, 'metric-data.xlsx');
        }
      })
      .catch(this.handleError);
  }

  getLTCMapDownloadableReport(): Observable<any> {
    let body = '';
    let headers = new Headers({ 
      'Authorization': `bearer ${localStorage.getItem('bearer')}`,
      'Accept': 'application/vnd.ms-excel',
    });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetLTCMapDownloadableReport', body, { responseType: ResponseContentType.Blob, headers  })
      .map((res: Response) => {        
        var blob = new Blob([res.blob()], { type: 'application/vnd.ms-excel' });

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, 'metric-data.xlsx');
        }
        else {
          //var url = window.URL.createObjectURL(blob);
          //window.open(url);
          saveAs(blob, 'ltc-map-metric-data.xlsx');
        }
      })
      .catch(this.handleError);
  }

  getAdvisorMetricData(metricObject): Observable<any> {
    let body = metricObject;
    let headers = new Headers({ 
      'Authorization': `bearer ${localStorage.getItem('bearer')}`,
      'Accept': 'application/vnd.ms-excel',
    });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetAdvisorMetrics', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  getClientMetricData(metricObject): Observable<any> {
    let body = metricObject;
    let headers = new Headers({ 
      'Authorization': `bearer ${localStorage.getItem('bearer')}`,
      'Accept': 'application/vnd.ms-excel',
    });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetClientMetrics', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  getGlobalOAMetricData(metricObject): Observable<any> {
    let body = metricObject;
    let headers = new Headers({ 
      'Authorization': `bearer ${localStorage.getItem('bearer')}`,
      'Accept': 'application/vnd.ms-excel',
    });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetGlobalOAMetrics', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  getGlobalMetricData(metricObject): Observable<any> {
    let body = metricObject;
    let headers = new Headers({ 
      'Authorization': `bearer ${localStorage.getItem('bearer')}`,
      'Accept': 'application/vnd.ms-excel',
    });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetGlobalMetrics', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  getGlobalSearchMetricData(metricObject): Observable<any> {
    let body = metricObject;
    let headers = new Headers({ 
      'Authorization': `bearer ${localStorage.getItem('bearer')}`,
      'Accept': 'application/vnd.ms-excel',
    });
    let options = new RequestOptions({ headers });

    return this.http.post(env + 'CoreOrganization/GetGlobalSearchMetrics', body, options)
      .map((res: Response) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  getSubstantialEarningYears(): Observable<any> {
    let body = { };
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post(env + 'CoreOrganization/GetSubstantialEarningYears', body, options)
      .map((res: any) => {
        return res.json();
      })
      .catch(this.handleError);
  }

  private handleError(error: any) {
    console.log('error',error);
    if (error.status === 401) {
      // BOTH
      localStorage.clear();
      window.location.href = window.location.origin;
    }

    return Observable.throw(error);
  }

  //ZSS added this for the Public pages
  post<T>(url: string, model: any): Observable<any> {
    let body = model;

    return this._http.post(env + url, body, {
      headers: new HttpHeaders().set('Content-Type', 'application/json')
        .set('Accept', 'application/json')
    })
      .catch(this.handleError);
  }

  getRetirementYear(retirementAge, dob) {
    var currentAge = this.calculateAge(dob);
    var diff = retirementAge - currentAge;
    var year = new Date().getFullYear();
    return year + diff;
  }
  /* calculateAge(birthday) {
    birthday = new Date(birthday);
    var ageDifMs = Date.now() - birthday;
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  } */


  calculateAge(birthday) {
    var bday = new Date(birthday);
    var today = new Date();
    return today.getFullYear() - bday.getFullYear();
  }

  calculateAgeV2(birthday) {
    var bday = new Date(birthday);
    var today = new Date();

    var age = today.getFullYear() - bday.getFullYear();

    if (
      today.getMonth() < bday.getMonth() ||
      (today.getMonth() === bday.getMonth() && today.getDate() < bday.getDate())
    ) {
      age--;
    }
    return age;
  }

  getRiskTolerancePortfolio(riskToleranceModel: any): Observable<any> {
    let body = riskToleranceModel;
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    return this.http.post(env + 'CoreReports/GetRiskTolerancePortfolio', body, options)
    .map((res: Response) => {
      return res.json();
    })
    .catch(this.handleError);
  }

  getClientRiskTolerance(riskToleranceModel: any): Observable<any> {
    let body = riskToleranceModel;
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    return this.http.post(env + 'CoreReports/GetClientRiskTolerance', body, options)
    .map((res: Response) => {
      return res.json();
    })
    .catch(this.handleError);
  }

  updateClientRiskTolerance(riskToleranceModel: any): Observable<any> {
    let body = riskToleranceModel;
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    return this.http.post(env + 'CoreOrganization/UpdateClientRiskTol', body, options)
    .map((res: Response) => {
      return res;
    })
    .catch(this.handleError);
  }

  //integrations
  wealthBoxIntegrationTest(token: string){
    //let body = riskToleranceModel;
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    return this.http.get(env + 'OAuth/testConnection?accessToken=' + token, options)
    .map((res: Response) => {
      return res;
    })
    .catch(this.handleError);
  }
}
